import Login from "../pages/auth/Login";
import Dashboard from "../pages/Dashboard";
import PayIn from "../pages/PayIn";
import {
    DashboardOutlined,
    MoneyCollectOutlined,
    TransactionOutlined,
    WalletOutlined,
    BankOutlined,
    SettingOutlined,
    PieChartOutlined,
    LineChartOutlined,
    HistoryOutlined,
    BookOutlined,
    UserOutlined,
    TeamOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    SwapOutlined,
    AccountBookOutlined,
    DollarOutlined,
    PlusCircleOutlined,
    BarChartOutlined,
    CalculatorOutlined,
    UsergroupAddOutlined,
    StopOutlined,
    CloudServerOutlined,
    EyeInvisibleOutlined,
    ApiOutlined
} from '@ant-design/icons';
import ItemLabel from "../components/TopMenu/ItemLabel/ItemLabel";
import Verify from "../pages/auth/Verify";
import Configure from "../pages/Configure";
import Bank from "../pages/Bank";
import BankAccount from "../pages/BankAccount";
import Transaction from "../pages/Transaction";
import Hook from "../pages/Hook";
import AdminHook from "../pages/admin/Hook"
import BankRequestLog from "../pages/admin/BankRequestLog";
import Withdraw from "../pages/Withdraw";
import PayOut from "../pages/PayOut";
import Partner from "../pages/Partner";
import ChildPartner from "../pages/ChildPartner";
import AdminTransaction from "../pages/admin/Transaction";
import AdminPayIn from "../pages/admin/PayIn";
import AdminPayOut from "../pages/admin/PayOut";
import HiddenPayIn from "../pages/admin/HiddenPayIn";
import BankTransaction from "../pages/BankTransaction";
import AdminWithdraw from "../pages/admin/Withdraw";
import AdminStatistic from "../pages/admin/Statistic";
import Statistic from "../pages/Statistic";
import WithdrawTransaction from "../pages/WithdrawTransaction";
import WithdrawAuto from "../pages/admin/WithdrawAuto";
import Administration from "../pages/Administration";
import WalletAccount from "../pages/WalletAccount";
import Deposit from "../pages/Deposit";
import AdminDeposit from "../pages/admin/Deposit";
import TopTransactions from "../pages/TopTransactions";
import Profit from "../pages/admin/Profit";
import BlockedBanks from "../pages/BlockedBanks";
import DeductionFee from "../pages/admin/DeductionFee";
import PartnerStatistic from "../pages/admin/PartnerStatistic";
import Proxy from "../pages/Proxy";

const authRoutes = [
    {
        path: '/auth/login',
        element: <Login/>
    },
    {
        path: '/auth/verify',
        element: <Verify/>
    }
];

const appRoutes = [
    {
        type: 'item',
        icon: <DashboardOutlined />,
        path: '/',
        element: <Dashboard/>,
        label: 'Trang chủ',
        key: 'dashboard',
        roles: ['admin', 'supporter','partner', 'child_partner']
    },
    {
        type: 'group',
        label: <ItemLabel>GIAO DỊCH</ItemLabel>,
        roles: ['admin','supporter'],
        permissions: ["manage_pay_in", "manage_pay_out", "manage_deposits", "manage_withdrawals"]
    },
    {
        type: 'item',
        icon: <ArrowDownOutlined />,
        path: '/admin/pay-in',
        element: <AdminPayIn/>,
        label: 'PAY IN',
        key: 'admin_pay_in',
        roles: ['admin','supporter'],
        permissions: ["manage_pay_in", "manage_deposits"]
    },
    {
        type: 'item',
        icon: <ArrowUpOutlined />,
        path: '/admin/pay-out',
        element: <AdminPayOut/>,
        label: 'PAY OUT',
        key: 'admin_pay_out',
        roles: ['admin','supporter'],
        permissions: ["manage_pay_out", "manage_withdrawals"]
    },
    {
        type: 'item',
        icon: <SwapOutlined />,
        path: '/admin/withdraw',
        element: <AdminWithdraw/>,
        label: 'Rút số dư',
        key: 'admin_withdraw',
        roles: ['admin', 'supporter'],
        permissions: ["manage_withdrawals"]
    },
    {
        type: 'item',
        icon: <PlusCircleOutlined />,
        path: '/admin/deposit',
        element: <AdminDeposit/>,
        label: 'Nạp số dư',
        key: 'admin_deposit',
        roles: ['admin', 'supporter'],
        permissions: ["manage_deposits"]
    },
    {
        type: 'group',
        label: <ItemLabel>CHỨC NĂNG</ItemLabel>,
        roles: ['partner', 'child_partner'],
        permissions: ["manage_pay_in", "manage_pay_out", "view_pay_in", "view_pay_out", "manage_deposits", "view_deposits"]
    },
    {
        type: 'item',
        icon: <ArrowDownOutlined />,
        path: '/pay-in',
        element: <PayIn/>,
        label: 'PAY IN',
        key: 'pay_in',
        roles: ['partner', 'child_partner'],
        permissions: ["view_pay_in"]
    },
    {
        type: 'item',
        icon: <ArrowUpOutlined />,
        path: '/pay-out',
        element: <PayOut/>,
        label: 'PAY OUT',
        key: 'pay_out',
        roles: ['partner', 'child_partner'],
        permissions: ["view_pay_out"]
    },
    {
        type: 'item',
        icon: <MoneyCollectOutlined />,
        path: '/transactions/withdraw',
        element: <Withdraw/>,
        label: 'Rút số dư',
        key: 'withdraw',
        roles: ['partner', 'child_partner'],
        permissions: ["view_withdrawals"]
    },
    {
        type: 'item',
        icon: <PlusCircleOutlined />,
        path: '/deposit',
        element: <Deposit/>,
        label: 'Nạp số dư',
        key: 'deposit',
        roles: ['partner', 'child_partner'],
        permissions: ["view_deposits"]
    },
    {
        type: 'group',
        label: <ItemLabel>CẤU HÌNH</ItemLabel>,
        roles: ['admin', 'supporter'],
        permissions: ["manage_settings"]
    },
    {
        type: 'item',
        icon: <SettingOutlined />,
        path: '/configure',
        element: <Configure/>,
        label: 'Cấu hình',
        key: 'configure',
        roles: ['admin', 'supporter'],
        permissions: ["manage_settings"]
    },
    {
        type: 'item',
        icon: <BankOutlined />,
        path: '/configure/bank',
        element: <Bank/>,
        label: 'Cấu hình ngân hàng',
        key: 'bank',
        roles: ['admin', 'supporter'],
        permissions: ["manage_settings", "manage_banks"]
    },
    {
        type: 'item',
        icon: <StopOutlined />,
        path: '/blocked-banks',
        element: <BlockedBanks/>,
        label: 'Ngân hàng bị chặn',
        key: 'blocked_banks',
        roles: ['admin','supporter', 'partner'],
        permissions: ["manage_blocked_banks"]
    },
    {
        type: 'item',
        icon: <CloudServerOutlined />,
        path: '/admin/proxy',
        element: <Proxy/>,
        label: 'Quản lý Proxy',
        key: 'proxy',
        roles: ['admin','supporter'],
        permissions: ["manage_settings"]
    },
    {
        type: 'item',
        icon: <TransactionOutlined />,
        path: '/withdraw-auto/account',
        element: <WithdrawAuto/>,
        label: 'Rút tiền tự động',
        key: 'withdraw_auto_account',
        roles: ['admin'],
        permissions: ["manage_settings", "manage_bank_withdrawals", "manage_withdrawals"]
    },
    {
        type: 'group',
        label: <ItemLabel>TÀI KHOẢN</ItemLabel>,
        roles: ['admin', 'supporter'],
        permissions: ["manage_banks"]
    },
    {
        type: 'item',
        icon: <WalletOutlined />,
        path: '/configure/bank-account/wallet',
        element: <WalletAccount/>,
        label: 'Ví điện tử',
        key: 'bank_account_wallet',
        roles: ['admin', 'supporter'],
        permissions: ["manage_banks", "manage_bank_transactions"]
    },
    {
        type: 'item',
        icon: <AccountBookOutlined />,
        path: '/configure/bank-account',
        element: <BankAccount/>,
        label: 'Ngân hàng',
        key: 'bank_account',
        roles: ['admin', 'supporter'],
        permissions: ["manage_banks", "manage_bank_transactions"]
    },
    {
        type: 'group',
        label: <ItemLabel>THỐNG KÊ</ItemLabel>,
        roles: ['admin','partner', 'supporter', 'child_partner'],
        permissions: ["view_statistics"]
    },
    {
        type: 'item',
        icon: <PieChartOutlined />,
        path: '/admin/statistic/in',
        element: <AdminStatistic type={'in'}/>,
        label: 'PAY IN',
        key: 'admin_statistic_in',
        roles: ['admin', 'supporter'],
        permissions: ["view_statistics"]
    },
    {
        type: 'item',
        icon: <PieChartOutlined />,
        path: '/admin/statistic/out',
        element: <AdminStatistic type={'out'}/>,
        label: 'PAY OUT',
        key: 'admin_statistic_out',
        roles: ['admin', 'supporter'],
        permissions: ["view_statistics"]
    },
    {
        type: 'item',
        icon: <CalculatorOutlined />,
        path: '/admin/profit',
        element: <Profit/>,
        label: 'Lợi nhuận',
        key: 'admin_profit',
        roles: ['admin'],
        permissions: ["view_statistics"]
    },
    {
        type: 'item',
        icon: <PieChartOutlined />,
        path: '/statistic/',
        element: <Statistic/>,
        label: 'Tổng quan',
        key: 'statistic',
        roles: ['partner', 'child_partner'],
        permissions: ["view_statistics"]
    },
    {
        type: 'item',
        icon: <BarChartOutlined />,
        path: '/top-transactions',
        element: <TopTransactions/>,
        label: 'Top Giao dịch',
        key: 'top_transactions',
        roles: ['partner', 'child_partner'],
        permissions: ["view_statistics"]
    },
    {
        type: 'group',
        label: <ItemLabel>LỊCH SỬ</ItemLabel>,
        roles: ['admin', 'partner', 'supporter', 'child_partner']
    },
    {
        type: 'item',
        icon: <LineChartOutlined />,
        path: '/admin/transactions/',
        element: <AdminTransaction/>,
        label: 'Biến động số dư',
        key: 'admin_transaction',
        roles: ['admin', 'supporter'],
        permissions: ["view_transactions"]
    },
    {
        type: 'item',
        icon: <HistoryOutlined />,
        path: '/admin/bank-transactions/',
        element: <BankTransaction/>,
        label: 'Giao dịch ngân hàng',
        key: 'admin_bank_transaction',
        roles: ['admin', 'supporter'],
        permissions: ["manage_bank_transactions"]
    },
    {
        type: 'item',
        icon: <DollarOutlined />,
        path: '/admin/withdraw-transactions/',
        element: <WithdrawTransaction/>,
        label: 'Rút tiền ngân hàng',
        key: 'admin_withdraw_transaction',
        roles: ['admin' , 'supporter'],
        permissions: ["manage_bank_withdrawals"]
    },
    {
        type: 'item',
        icon: <BookOutlined />,
        path: '/admin/log-webhook/hook-api',
        element: <AdminHook/>,
        label: 'Lịch sử hook',
        key: 'admin/log_hook',
        roles: ['admin', 'supporter'],
        permissions: ["view_hooks"]
    },
    {
        type: 'item',
        icon: <ApiOutlined />,
        path: '/admin/log-bank-request',
        element: <BankRequestLog/>,
        label: 'Log request ngân hàng',
        key: 'admin/log_bank_request',
        roles: ['admin'],
        permissions: ["manage_banks"]
    },
    {
        type: 'item',
        icon: <LineChartOutlined />,
        path: '/transactions/',
        element: <Transaction/>,
        label: 'Biến động số dư',
        key: 'transaction',
        roles: ['partner', 'child_partner'],
        permissions: ["view_transactions"]
    },
    {
        type: 'item',
        icon: <BookOutlined />,
        path: '/log-webhook/hook-api',
        element: <Hook/>,
        label: 'Lịch sử hook',
        key: 'log_hook',
        roles: ['partner', 'child_partner'],
        permissions: ["view_hooks"]
    },
    {
        type: 'group',
        label: <ItemLabel>QUẢN LÝ</ItemLabel>,
        roles: ['admin', 'supporter', 'partner']
    },
    {
        type: 'item',
        icon: <UserOutlined />,
        path: '/admin/partner',
        element: <Partner/>,
        label: 'Đối tác',
        key: 'partner',
        roles: ['admin', 'supporter'],
        permissions: ["manage_partners"]
    },
    {
        type: 'item',
        icon: <UsergroupAddOutlined />,
        path: '/child-partner',
        element: <ChildPartner/>,
        label: 'Tài khoản con',
        key: 'child_partner',
        roles: ['partner'],
        permissions: ["manage_child_partners"]
    },
    {
        type: 'item',
        icon: <DollarOutlined />,
        path: '/admin/deduction-fee',
        element: <DeductionFee/>,
        label: 'Tiền trừ đối tác',
        key: 'admin_deduction_fee',
        roles: ['admin', 'supporter'],
        permissions: ["manage_partners"]
    },
    {
        type: 'item',
        icon: <EyeInvisibleOutlined />,
        path: '/admin/pay-in/hidden',
        element: <HiddenPayIn/>,
        label: 'PAY IN BỊ ẨN',
        key: 'admin_hidden_pay_in',
        roles: ['admin','supporter'],
        permissions: ["manage_pay_in"]
    },
    {
        type: 'item',
        icon: <TeamOutlined />,
        path: '/admin/administration',
        element: <Administration/>,
        label: 'Quản trị',
        key: 'administration',
        roles: ['admin'],
        permissions: ["manage_administrators"]
    },
    {
        type: 'item',
        icon: <PieChartOutlined />,
        path: '/admin/partner-statistic/:userId',
        element: <PartnerStatistic/>,
        label: 'Thống kê đối tác',
        key: 'partner_statistic',
        roles: ['admin'],
        permissions: ["manage_partners"],
        hidden: true
    },
];

const redirectAuth = '/auth/login';

const redirectApp = '/';

export {authRoutes,appRoutes,redirectAuth,redirectApp};
